"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dateRegex = _interopRequireDefault(require("../constants/dateRegex"));

var _default = function _default(input) {
  if (typeof input !== 'string') {
    return false;
  }

  return _dateRegex.default.test(input);
};

exports.default = _default;
module.exports = exports.default;